import { CentralMetadata } from "./central-metadata";
import { ConnectedAppParameter } from "./connected-app";
import { ExternalOperationCommonSettings } from "./external-operation-common-settings";
import { FileClass } from "./file-class";

export enum FileClassExternalOperationParameterBindType {
    UPLOADED_FILE = 1,
    CONSTANT_VALUE = 2,
    SCRIPT = 3,
    METADATA = 4
}
export interface FileClassExternalOperation {
    id?: number;
    
    file_class_id: number;
    file_class: FileClass;

    external_operation_common_settings_id: number;
    external_operation_common_settings: ExternalOperationCommonSettings;

    parameters?: FileClassExternalOperationParameter[];
}

export interface FileClassExternalOperationParameter {
    id?: number;

    bind_type?: FileClassExternalOperationParameterBindType;
    constant_value?: string;
    script?: string;
    
    central_metadata_id?: number;
    central_metadata?: CentralMetadata;

    connected_app_parameter_id: number;
    connected_app_parameter: ConnectedAppParameter;

    file_class_external_operation_id: number;
    file_class_external_operation: FileClassExternalOperation;
}